import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-header-block',
  templateUrl: './header-block.component.html',
  styleUrls: ['./header-block.component.scss']
})
export class HeaderBlockComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
